<mat-card class="widget">
  <div class="fab-buttons">
    @if (!isStreapper) {
      <img src="/assets/images/lock-solid.png" class="lock" alt="slot"/>
    } @else {
      @if (!editMode) {
        <fab-no-title [icon]="'edit'" (click)="edit()"></fab-no-title>
      }
      @if (editMode) {
        <fab-no-title class="close" [icon]="'close'" (click)="cancel()"></fab-no-title>
      }
      @if (editMode) {
        <fab-no-title [style]="getFabStyle()" [icon]="'save'" (click)="save()"></fab-no-title>
      }
    }
  </div>
  <div class="about-content">
    <h1>{{ 'profile.about_me' | translate }}</h1>
    <div class="about-content-container">
      @if (!editMode) {
        <div class="text">
          <span>{{ description }}</span>
        </div>
      }
      @if (editMode) {
        <div>
          <form [formGroup]="profileFormGroup">
            <mat-form-field appearance="outline">
              <mat-label>{{ "profile.aboutme_label" | translate }}</mat-label>
              <textarea
                #aboutme
                required
                maxlength="500"
                autosize
                rows="3"
                minRows="3"
                maxRows="10"
                formControlName="aboutme"
                matInput
                [placeholder]="'profile.aboutme_placeholder' | translate"
              ></textarea>
              <span class="character-counter">{{ aboutme.value.length }} / {{ aboutme.maxLength }}</span>
              <mat-error>{{ "profile.aboutme_validation" | translate }}</mat-error>
            </mat-form-field>
          </form>
        </div>
      }
    </div>
  </div>
</mat-card>